export default [{
  path: '/enquired',
  name: 'Enquired',
  component: () => import(/* webpackChunkName: 'Enquired' */ '@/views/enquired/index.vue'),
  children: [
    { // 新建询价
      path: 'edit',
      name: 'EnquiredEdit',
      component: () => import(/* webpackChunkName: 'Enquired' */ '@/views/enquired/edit'),
      meta: {
        title: '新建询价',
      },
    },
    { // 询价记录
      path: 'list',
      name: 'EnquiredList',
      component: () => import(/* webpackChunkName: 'Enquired' */ '@/views/enquired/list'),
      meta: {
        title: '询价记录',
        keepAlive: true,
      },
    },
    { // 询价详情
      path: 'detail',
      name: 'EnquiredDetail',
      component: () => import(/* webpackChunkName: 'Enquired' */ '@/views/enquired/detail'),
      meta: {
        title: '询价详情',
      },
    },
    { // 导航
      path: 'guide',
      name: 'EnquiredRouterGuide',
      component: () => import(/* webpackChunkName: 'Enquired' */ '@/views/enquired/router-guide'),
    },
  ],
}];
